import { useState, useEffect } from 'react';

const useTextSplitter = (initialText) => {
  const [text, setText] = useState([]);

  useEffect(() => {
    if (initialText) {
      const newText = initialText.split('\r\n');
      setText(newText);
    }
  }, [initialText]);

  return text;
};

export default useTextSplitter;
